<template>
  <div style="position: relative; height: calc(100vh - 15vh)">
    <div
      style="position: relative; height: calc(100vh - 25vh); overflow-y: auto"
    >
      <el-form
        style="margin-top: 2%"
        ref="dataForm"
        :rules="rules"
        :model="listInfo"
        label-position="top"
        class="m-4 text-left"
      >
        <el-form-item label="建议标题" prop="title">
          <el-input
            v-model="listInfo.title"
            clearable
            type="textarea"
            rows="2"
            maxlength="50"
            placeholder="请输入建议标题（0 ~ 50字）"
          ></el-input>
        </el-form-item>
        <el-form-item label="投诉建议内容" prop="complaintContent">
          <el-input
            v-model="listInfo.complaintContent"
            clearable
            type="textarea"
            rows="20"
            maxlength="500"
            placeholder="请简要输入建议内容，系统会将您的建议提交至省级中心（0 ~ 500字）"
          ></el-input>
        </el-form-item>
        <span style="font-size: 12px; float: right">{{
          "您还可输入 " + residueNumber + " 字数"
        }}</span>
      </el-form>
    </div>
    <div style="width: 100%">
      <el-button
        type="primary"
        style="width: 92%; margin: 4% 1%; background: #fff; color: #409eff"
        plain
        @click="submit"
        >提 交</el-button
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "Advice",
  data () {
    return {
      listInfo: {
        title: "",
        complaintContent: ""
      },

      residueNumber: 500,
      rules: {
        title: [{ required: true, message: '请输入建议标题', trigger: 'blur' }],
        complaintContent: [{ required: true, message: '请输入投诉建议内容', trigger: 'blur' }],
      },
    };
  },
  watch: {
    'listInfo.complaintContent' (newVal) {
      this.residueNumber = 500 - newVal.length
    }
  },
  created () {
    this.listInfo = {
      title: "",
      complaintContent: ""
    }
    this.residueNumber = 500
  },
  methods: {
    submit () {
      this.$refs['dataForm'].validate(valid => {
        if (valid) {
          let json = {
            AdviceTitle: this.listInfo.title,
            AdviceContent: this.listInfo.complaintContent,
            OrganID: this.getOrganID()
          };
          // console.log("投诉提交参数：", JSON.stringify(json))

          this.apiAddAdviceInfoAPIPost(json, this, e => {
            this.$toast(e.message);
            if (e.code == 20000) {
              this.$router.push("/AdviceList");
            }
          });
        }
      })
    },
  }
};
</script>

<style scoped>
#ChangePwd {
  background: #efefef;
  min-height: 700px;
}
::v-deep .el-form--label-top .el-form-item__label {
  float: none;
  display: inline-block;
  text-align: left;
  padding: 0px;
  font-weight: 550;
}
::v-deep .el-textarea__inner {
  border-radius: 12px;
}
::v-deep .el-form-item {
  margin-bottom: 5px;
}
</style>
